// extracted by mini-css-extract-plugin
export default {"Toggles":"Toggles_Toggles__Pclm1","Toggles__theme":"Toggles_Toggles__theme__T70RY","Toggles__lang":"Toggles_Toggles__lang__v1UM6"};